import { z } from "zod";
import { CommonModels } from "@/data/common/common.models";

export namespace LiveShowsModels {
/** 
 * LiveShowsGetPastResponseSchema 
 * @type { object }
 * @property { object[] } order List of order definitions 
 * @property { number } page 1-indexed page number to begin from 
 * @property { string } cursor ID of item to start after 
 * @property { string } nextCursor Cursor for next set of items 
 * @property { number } limit Items per response 
 * @property { number } totalItems Total available items 
 * @property { CommonModels.LiveShowResponseDto[] } items  
 */
export const LiveShowsGetPastResponseSchema = z.object({ ...CommonModels.PaginationDtoSchema.shape, ...z.object({ items: z.array(CommonModels.LiveShowResponseDtoSchema).nullable() }).partial().shape });
export type LiveShowsGetPastResponse = z.infer<typeof LiveShowsGetPastResponseSchema>;


/** 
 * LiveShowsGetUpcomingResponseSchema 
 * @type { object }
 * @property { object[] } order List of order definitions 
 * @property { number } page 1-indexed page number to begin from 
 * @property { string } cursor ID of item to start after 
 * @property { string } nextCursor Cursor for next set of items 
 * @property { number } limit Items per response 
 * @property { number } totalItems Total available items 
 * @property { CommonModels.LiveShowResponseDto[] } items  
 */
export const LiveShowsGetUpcomingResponseSchema = z.object({ ...CommonModels.PaginationDtoSchema.shape, ...z.object({ items: z.array(CommonModels.LiveShowResponseDtoSchema).nullable() }).partial().shape });
export type LiveShowsGetUpcomingResponse = z.infer<typeof LiveShowsGetUpcomingResponseSchema>;


/** 
 * LiveShowsGetCurrentResponseSchema 
 * @type { array }
 */
export const LiveShowsGetCurrentResponseSchema = z.array(CommonModels.LiveShowResponseDtoSchema);
export type LiveShowsGetCurrentResponse = z.infer<typeof LiveShowsGetCurrentResponseSchema>;


/** 
 * GetUploadedVideosResponseSchema 
 * @type { object }
 * @property { object[] } order List of order definitions 
 * @property { number } page 1-indexed page number to begin from 
 * @property { string } cursor ID of item to start after 
 * @property { string } nextCursor Cursor for next set of items 
 * @property { number } limit Items per response 
 * @property { number } totalItems Total available items 
 * @property { CommonModels.LiveShowResponseDto[] } items  
 */
export const GetUploadedVideosResponseSchema = z.object({ ...CommonModels.PaginationDtoSchema.shape, ...z.object({ items: z.array(CommonModels.LiveShowResponseDtoSchema).nullable() }).partial().shape });
export type GetUploadedVideosResponse = z.infer<typeof GetUploadedVideosResponseSchema>;


}
